"use client";

import { FC } from "react";
import { uniqueId } from "lodash";

import useStateData from "@/hooks/useStateData";
import { PROJECT_FILTER_OPTIONS } from "@/lib/utils";

const ProjectSelect: FC = () => {
  const { selectedFilter, handleSelectFilter } = useStateData();

  return (
    <select
      className="select dark:bg-secondary-dark focus:outline-none"
      onChange={(e) => handleSelectFilter(e.target.value)}
      value={selectedFilter}
    >
      {PROJECT_FILTER_OPTIONS.map((item) => (
        <option key={uniqueId("filter")} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};

export default ProjectSelect;
